import React from "react";
import { motion } from "framer-motion";
import uaMap from "../assets/images/65bb8d18f1588fbb0e7067f2_2.webp";
import plMap from "../assets/images/65bb8d19ae72ebf20b165dd9_3.webp";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 50 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

function Offices() {
  return (
    <section className="offices">
      <motion.div
        className="offices__container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }} // Триггер срабатывает, когда 50% контейнера в зоне видимости
      >
        <motion.div
          className="offices__card offices__main"
          variants={cardVariants}
        >
          <div className="offices__main-content">
            <h2 className="offices__title">ОФIСИ У ДВОХ КРАIНАХ</h2>
            <a href="" className="offices__cta">
              <span className="offices__cta-text">ПРИЄДНАТИСЬ ДО НАС</span>
              <span className="offices__cta-plus">+</span>
            </a>
          </div>
        </motion.div>

        <motion.div className="offices__card" variants={cardVariants}>
          <span className="offices__number">[ 01 ]</span>
          <img src={uaMap} alt="Україна" className="offices__image" />
          <h3 className="offices__country">УКРАЇНА</h3>
        </motion.div>

        <motion.div className="offices__card" variants={cardVariants}>
          <span className="offices__number">[ 02 ]</span>
          <img src={plMap} alt="Польща" className="offices__image" />
          <h3 className="offices__country">ПОЛЬЩА</h3>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Offices;
